var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar",class:_vm.classBar},[_c('div',{staticClass:"barPrecent",class:_vm.classProgress,style:(_vm.styleProcess)}),(_vm.showText)?_c('span',{staticClass:"info"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }